/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { InfoCardKernelType, OfferInfoCardKernel } from 'client-code/actions';

import { APPLICATION_FEATURE_AREA } from '../../config';
import {
    IInfoCard,
    IInfoCardProperty,
    InfoCardManager,
    InfoCardUserInputHandler,
} from '../infocard';
import { NdvrInteractor } from '../interactors';
import { Log } from '../logging';
import { TUpcomingOffer } from '../types';

export class ProgramScreenInfoCardUserInputHandler extends InfoCardUserInputHandler {
    private mInfoCard: IInfoCard = InfoCardManager.getInstance();

    private async horizontalKeyNavigationHelper(direction: 'left' | 'right'): Promise<void> {
        const { offset, totalCount, id } = (this.mInfoCard.getContextData(
            ProgramScreenInfoCardUserInputHandler.name,
        ) || {}) as { offset: number; totalCount: number; id: string };

        const nextOffset =
            direction === 'left'
                ? (offset - 1 + totalCount) % totalCount
                : (offset + 1) % totalCount;
        let item: TUpcomingOffer;

        try {
            [item] = (
                await new NdvrInteractor().getUpcomingOffersForCollectionId({
                    objectId: id,
                    minEndTime: new Date().toISOString(),
                    offset: nextOffset,
                    limit: 1,
                    screenType: APPLICATION_FEATURE_AREA.PROGRAM_SCREEN,
                })
            ).upcomingOffers;
        } catch (error) {
            Log.e(
                'ProgramScreenInfoCardUserInputHandler',
                'Error fetching item for navigation',
                error,
            );
            this.mInfoCard.dismiss();
            return;
        }

        this.mInfoCard.hideActionButtons();
        this.mInfoCard.setInfoCardKernel({
            infoCardKernelType: InfoCardKernelType.OfferInfoCardKernel,
            offerId: item.offerId,
        } as OfferInfoCardKernel);
        this.mInfoCard.setProperties({
            hasItemsBefore: totalCount > 1,
            hasItemsAfter: totalCount > 1,
        });
        this.mInfoCard.setContextData(ProgramScreenInfoCardUserInputHandler.name, {
            offset: nextOffset,
            totalCount,
            id,
        });
    }

    /**
     * @override
     */
    public onKeyLeft(properties: IInfoCardProperty): void {
        if (!properties.hasItemsBefore) return;
        this.horizontalKeyNavigationHelper('left');
    }

    /**
     * @override
     */
    public onKeyRight(properties: IInfoCardProperty): void {
        if (!properties.hasItemsAfter) return;
        this.horizontalKeyNavigationHelper('right');
    }
}
